import { render, staticRenderFns } from "./UserInfoPage.vue?vue&type=template&id=4ca67d48&scoped=true&"
import script from "./UserInfoPage.vue?vue&type=script&lang=js&"
export * from "./UserInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoPage.vue?vue&type=style&index=0&id=4ca67d48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca67d48",
  null
  
)

export default component.exports